/* eslint-disable react-refresh/only-export-components -- provider + hooks co-locados de propósito */
import { createContext, useContext, useEffect, useState, type ComponentType, type ReactNode } from 'react'

/** Título/eyebrow que uma página empurra para o Topbar (libera a área útil do corpo). */
export interface TopbarChrome {
  eyebrow?: string
  title?: string
  /** Ação da página, ao lado do título. COMPONENTE, não elemento: o Topbar guarda
   *  o chrome em estado e um elemento novo a cada render reentraria no efeito sem
   *  parar. Declarado no módulo da página, a identidade é constante. */
  Action?: ComponentType
}

const ChromeCtx = createContext<TopbarChrome>({})
const SetChromeCtx = createContext<(c: TopbarChrome) => void>(() => {})

export function PageChromeProvider({ children }: { children: ReactNode }) {
  const [chrome, setChrome] = useState<TopbarChrome>({})
  return (
    <SetChromeCtx.Provider value={setChrome}>
      <ChromeCtx.Provider value={chrome}>{children}</ChromeCtx.Provider>
    </SetChromeCtx.Provider>
  )
}

/** Lido pelo Topbar. */
export const useTopbarChrome = () => useContext(ChromeCtx)

/** Chamado por uma página p/ mostrar o título no Topbar (limpa ao desmontar).
 *  `Action` é opcional e aparece ao lado do título — é o atalho da própria tela. */
export function useSetTopbarTitle(title: string, eyebrow?: string, Action?: ComponentType) {
  const set = useContext(SetChromeCtx)
  useEffect(() => {
    set({ title, eyebrow, Action })
    return () => set({})
  }, [title, eyebrow, Action, set])
}
